import { Component, input } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FHIRAllergyIntolerance } from '../../../../models';

@Component({
  selector: 'app-allergies-section',
  standalone: true,
  imports: [CommonModule],
  templateUrl: './allergies-section.component.html',
  styles: [
    `
      .section-banner {
        display: flex;
        align-items: center;
        gap: 0.6rem;
        padding: 0.85rem 1.25rem;
        font-weight: 700;
        font-size: 1.05rem;
        border-radius: 6px 6px 0 0;
        background-color: #dc3545;
        color: #fff;
      }
      .section-banner i {
        font-size: 1.2rem;
      }
      .section-banner-body {
        padding: 1rem 1.25rem;
        border: 1px solid #dee2e6;
        border-top: none;
        border-radius: 0 0 6px 6px;
        background: #fff;
      }
    `,
  ],
})
export class AllergiesSectionComponent {
  readonly allergies = input.required<FHIRAllergyIntolerance[]>();

  getEstadoBadge(estado: string): { color: string; label: string } {
    const s = (estado || '').toLowerCase();
    if (s.includes('active') || s.includes('activ')) return { color: 'bg-danger', label: 'Activo' };
    if (s.includes('resolved') || s.includes('resuel'))
      return { color: 'bg-success', label: 'Resuelto' };
    return { color: 'bg-secondary', label: estado || 'N/A' };
  }

  getTipoBadge(tipo: string): { color: string; label: string } {
    const t = (tipo || '').toLowerCase();
    if (t === 'allergy') return { color: 'bg-danger', label: 'Alergia' };
    if (t === 'intolerance') return { color: 'bg-warning text-dark', label: 'Intolerancia' };
    return { color: 'bg-secondary', label: tipo || 'N/A' };
  }

  getCriticidadBadge(criticidad: string): { color: string; label: string } {
    const c = (criticidad || '').toLowerCase();
    if (c === 'high') return { color: 'bg-danger', label: 'Alta' };
    if (c === 'low') return { color: 'bg-success', label: 'Baja' };
    if (c === 'unable-to-assess') return { color: 'bg-secondary', label: 'No evaluable' };
    return { color: 'bg-warning text-dark', label: criticidad || 'N/A' };
  }
}
